import { BaseItem } from '../common';
import { PracticePreference } from '../previsit';
import { PrevisitForm } from './form';
import { PrevisitFormFieldWithConfig } from './formField';
import { Theme } from '../practice/theme';
import { Encounter, Practice, User } from '../index';

export enum Status {
  Created = 'CREATED',
  MessageSent = 'MESSAGE_SENT',
  MessageUndelivered = 'MESSAGE_UNDELIVERED',
  MessageDelivered = 'MESSAGE_DELIVERED',
  CannotReceiveNotification = 'CANNOT_RECEIVE_NOTIFICATION',
  FormSetStarted = 'FORM_SET_STARTED',
  FormSetCompleted = 'FORM_SET_COMPLETED',
  FormSetExpired = 'FORM_SET_EXPIRED',
}
export interface PrevisitFormSet extends BaseItem {
  ehrInformationId: string;
  encounterId: string | null;
  expires: Date;
  previsitLinkId: string | null;
  status: Status | null;
}

export interface PrevisitFormSetWithEhrInformation extends PrevisitFormSet {
  patientEhrId: string;
  patientId: string;
  practiceId: string;
}

export interface PrevisitFormSetWithForms extends PrevisitFormSet {
  intro: PrevisitFormFieldWithConfig;
  last: PrevisitFormFieldWithConfig;
  closedTimestamp: Date | null;
  forms: { [formId: string]: PrevisitForm };
  practicePreference: PracticePreference;
  theme: Theme;
  completed: Date | null;
}
export interface PrevisitFromSetWithPatientData {
  previsitFormSet: PrevisitFormSetWithForms;
  practice?: Practice.Practice;
  encounter?: Encounter.Encounter;
  provider?: User.User;
  virtualVisit?: boolean;
  covidInstruction?: string;
}
export interface PrevisitFormSetsResponse {
  formSets: PrevisitFromSetWithPatientData[];
}

export interface PrevisitFormSetWithFormsAndAuthCode
  extends PrevisitFormSetWithForms {
  authenticationCode?: string;
}
